var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCptArchived(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "12px",
    viewBox: "0 0 13 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CPT mark-archived") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABB3BE",
    offset: "0.199409965%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#393E46",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Full-value-Map-Search",
    transform: "translate(-902.000000, -754.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CPT-mark-archived",
    transform: "translate(902.000000, 754.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.76619038,0 L11.2338096,0 C11.7860944,-1.85966397e-15 12.2338096,0.44771525 12.2338096,1 C12.2338096,1.18124395 12.1845518,1.35908035 12.0913025,1.51449576 L7,10 L7,10 L7,11 L10.5,11 L10.5,12 L2.5,12 L2.5,11 L6,11 L6,10 L0.908697453,1.51449576 C0.624549294,1.04091549 0.778114358,0.426655234 1.25169462,0.142507074 C1.40711003,0.0492578333 1.58494643,2.55338578e-16 1.76619038,0 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCptArchived);
export default __webpack_public_path__ + "static/media/cpt_archived.b6842153f5c6ac2a0f580a36f607165d.svg";
export { ForwardRef as ReactComponent };